<nw-tab-group class="knowledge-centre__container">
    @for (tab of tabs; track tab; let index = $index) {
        <nw-tab [label]="tab">
            <div class="knowledge-centre__container__tab">
                @for (card of cards[tab]; track $index) {
                    <nw-article-card
                        [category]="card.category"
                        [categorycolor]="colors[index]"
                        [date]="card.date"
                        [tabindex]="$index"
                        [path]="card.path"
                        >{{ card.label }}</nw-article-card
                    >
                }
            </div>
        </nw-tab>
    }
</nw-tab-group>
